<template>
  <div class="main" :class="{ disable }">
    <div class="input" v-click-outside="() => (show = false)">
      <BaseText :title="title" :placeholder="title" :value="userName" classes="tags" @input="userName = $event" @focused="show = true" />
      <i class="fa-solid fa-caret-down icon-down" @click="show = !show"></i>
      <div v-if="show">
        <div v-if="!loading && list.length === 0 && empty" class="list-loading">نتیجه ای یافت نشد!</div>
        <div class="scroll">
          <div v-if="list.length" class="user-list">
            <div class="d-flex position-relative item" v-for="(item, index) in list" :key="index" @click="addSelectedUser(item)">
              <div class="user-image">
                <img v-if="item.image" :src="item.image" />
                <img v-else src="@/assets/images/users/default.png" />
              </div>
              <div class="user">
                <div class="name">{{ item.fullName }}</div>
                <div class="phone">{{ item.phone || '-' }}</div>
                <div class="nationalCode">{{ item.nationalCode || '-' }}</div>
              </div>
            </div>
          </div>
          <div v-if="list.length" class="add-user" @click="$bvModal.show('user-modal')">
            <img src="@/assets/images/purple-plus.svg" />
            اضافه کردن
          </div>
        </div>
      </div>
    </div>
    <b-modal id="user-modal" no-close-on-esc hide-footer centered header-close-variant="dark" cancel-title>
      <template #modal-title>کاربر جدید</template>
      <div class="px-3 py-2">
        <BaseText
          :value="model.firstName"
          @input="model.firstName = $event"
          title="نام"
          placeholder="نام"
          required
          :errortext="errorText"
          :showError="submit && !model.firstName"
        />
      </div>
      <div class="px-3 py-2">
        <BaseText
          :value="model.lastName"
          @input="model.lastName = $event"
          title="نام خانوادگی"
          placeholder="نام خانوادگی"
          required
          :errortext="errorText"
          :showError="submit && !model.lastName"
        />
      </div>
      <div class="px-3 py-2">
        <BaseText
          :value="model.mobile"
          @input="model.mobile = $event"
          title="تلفن همراه"
          placeholder="تلفن همراه"
          required
          :errortext="errorText"
          :showError="submit && !model.mobile"
        />
      </div>
      <div class="px-3 py-2">
        <BaseText :value="model.nationalCode" @input="model.nationalCode = $event" title="کدملی" placeholder="کدملی" />
      </div>
      <div class="p-3 py-2 d-flex flex-row justify-content-end">
        <b-button @click="closeModal">انصراف</b-button>
        <Button @click.native="createSearchUser" :loading="submitLoading" text="ثبت" btnClass="upload-btn btn-border" />
      </div>
    </b-modal>
    <Toast :showToast="showToast" :title="toastTitle" :error="error" />
  </div>
</template>

<script>
import BaseText from '../common/form/formModules/BaseText.vue'
import dadbanUsersProvider from '../../services/dadban/user'
import Button from '../common/Button.vue'
import Toast from '../common/Toast.vue'

export default {
  components: { BaseText, Button, Toast },
  props: {
    userId: {
      type: String,
    },
    title: {
      type: String,
      default: 'نام کاربری',
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userName: '',
      show: false,
      forceClose: false,
      list: [],
      model: {
        firstName: '',
        lastName: '',
        mobile: '',
        nationalCode: '',
      },
      loading: false,
      submitLoading: false,
      toastTitle: '',
      showToast: false,
      empty: false,
      submit: false,
      error: false,
      errorText: 'وارد کردن این فیلد الزامی است.',
    }
  },
  watch: {
    show(c) {
      if (c) {
        this.fetchSearchUsers()
      }
    },
    userName() {
      if (!this.forceClose) {
        this.show = true
        this.fetchSearchUsers()
      }
    },
    async userId() {
      const req = await dadbanUsersProvider.getUserById(this.userId)
      this.forceClose = true
      this.userName = req.data.data.peopleInfo.firstName + ' ' + req.data.data.peopleInfo.lastName
      setTimeout(() => {
        this.forceClose = false
      }, 1000)
    },
  },
  async mounted() {
    if (this.userId) {
      const req = await dadbanUsersProvider.getUserById(this.userId)
      this.forceClose = true
      this.userName = req.data.data.peopleInfo.firstName + ' ' + req.data.data.peopleInfo.lastName
      setTimeout(() => {
        this.forceClose = false
      }, 1000)
    }
  },
  methods: {
    async fetchSearchUsers() {
      this.loading = true
      const req = await dadbanUsersProvider.getSearchUsers(this.userName ? `?keyword=${this.userName || ''}&pageSize=100&pageNumber=1` : '?pageSize=100&pageNumber=1')
      this.list = req.data.data
      this.loading = false
    },
    async addSelectedUser(user) {
      this.userName = user.firstName + ' ' + user.lastName
      this.show = false
      this.forceClose = true
      this.$emit('update', user.id)
      setTimeout(() => {
        this.forceClose = false
      }, 1000)
    },
    async createSearchUser() {
      this.submit = true
      if (!this.model.firstName && !this.model.lastName && !this.model.mobile) {
        return false
      }
      this.submitLoading = true
      try {
        const req = await dadbanUsersProvider.createTeacherUser(this.model)
        this.submitLoading = false

        if (req.status === 200) {
          this.toastTitle = 'کاربر با موفقیت اضافه شد'
          this.showToast = true
          this.$bvModal.hide('user-modal')
          this.submit = false
          this.userName = this.model.firstName + ' ' + this.model.lastName
          this.$emit('update', req.data.data.peopleGuidId)
        }
        for (const key in this.model) {
          this.model[key] = ''
        }
      } catch (error) {
        this.submitLoading = false
        this.toastTitle = 'شماره همراه قبلا ثبت شده، لطفا شماره دیگری وارد کنید'
        this.error = true
        this.showToast = true
        for (const key in this.model) {
          this.model[key] = ''
        }
        setTimeout(() => {
          this.showToast = false
          this.error = false
        }, 5000)
      }
    },
    closeModal() {
      this.$bvModal.hide('user-modal')
      this.submitLoading = false
      this.submit = false
      this.toastTitle = ''
      this.showToast = false
      this.error = false
    },
  },
}
</script>

<style lang="scss" scoped>
.disable {
  opacity: 0.5;
  pointer-events: none;
}
.main {
  position: relative;
}
.input {
  position: relative;
}

.icon-down {
  position: absolute;
  left: 10px;
  top: 7px;
  color: #999696;
  cursor: pointer;
}

.list {
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  overflow-y: auto;
  height: 220px;
  width: 433px;
  // padding: 10px;
  padding-left: 0;
  position: absolute;
  top: 33px;
  right: 0;
  z-index: 100;
}

.list-loading {
  @extend .list;
  display: grid;
  place-items: center;
}

.item {
  padding: 15px 10px;
  &:hover {
    background: rgba(85, 110, 230, 0.1);
  }
}

.user {
  display: flex;
  width: 100%;
  justify-content: center;
  cursor: pointer;
  .name {
    position: relative;
    top: 5px;
    margin-right: 10px;
    width: 33%;
  }
  .phone,
  .nationalCode {
    width: 33%;
    color: #999696;
    text-align: center;
    margin-right: 50px;
    position: relative;
    top: 5px;
  }
}

.user-image {
  img {
    width: 28px;
    height: 28px;
    border-radius: 100%;
  }
}

.add-user {
  font-weight: 400;
  font-size: 13px;
  line-height: 21px;
  color: #556ee6;
  cursor: pointer;
  font-weight: bold;
  padding: 14px;
  border-top: 1px solid #e8e8e8;
  img {
    margin-left: 10px;
  }
}

.scroll {
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  height: 220px;
  width: calc(100% - 100px);
  // padding: 10px;
  padding-left: 0;
  position: absolute;
  top: 40px;
  right: 0;
  right: 100px;
  z-index: 100;
}
.user-list {
  overflow-y: auto;
  height: 170px;
}

.upload-btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
}
</style>
